import React from 'react';
import AddFormModal from './../../common/AddFormModal'
import EdiTable from '../../common/EdiTable'
import dataProvider from './../../common/dataProvider';
import Panel from '../../common/layout/Panel'

export default class extends React.Component {
    constructor (props) {
        super(props)
        this.state = {
            group_id: props.match.params.group_id,
            url: `/admin/products/calleridgroups/${props.match.params.group_id}/items`,
            data: {
                data: [],
                metadata: []
            },
            metadata:
                [
                    {
                        'label': 'id',
                        'source': 'ATRCALLERIDCODEID',
                        'type': 'primary',
                        'editable': false,
                        'visible': false
                    },
                    {
                        'label': 'Code (Prefix)',
                        'source': 'ATRCODE',
                        'type': 'text',
                        'editable': true,
                        'visible': true,
                        'placeholder': 'Country Code'
                    },
                    {
                        'label': 'Name',
                        'source': 'ATRNAME',
                        'type': 'text',
                        'editable': true,
                        'visible': true,
                        'placeholder': 'Country Name'
                    },
                    {
                        'label' : 'Actions',
                        'type': 'action_buttons'
                    }
                ]
        }
    }
    componentDidMount(){
        this.loadFromServer();
    }
    loadFromServer() {
        dataProvider.getList(this.state.url, {}).then(
            response => 
            this.setState({
                loading: false,
                data: response.data
            })
        );
    }
    onRowAdded(data) {
        var newdata = this.state.data;
        newdata.data.push(data);
        this.setState({data: newdata});
    }
    getObjectName(id) {
        const data = this.props.data;
        let name = ''
        data && data.data.map((item, i) => {
            if (item['ATRCALLERIDCODEBANDID'] === id) {
                name = item['ATRNAME'];
            }
        })
        return name;
    }
    render(){
        const group_id = this.state.group_id;
        const url = `/admin/products/calleridgroups/${group_id}/items`;
        const title = "Product Caller ID Group " + this.getObjectName(this.props.match.params.group_id)
        return(
            <Panel title = {title}>
                <div className="row">
                    <div className="col-md-12">
                        <div className="row">
                            <div className="col-md-12">
                                <AddFormModal
                                    bsStyle="add"
                                    addButton="true"
                                    addButtonValue="Add Caller ID Group Code"
                                    metadata={this.state.metadata}
                                    url={url}
                                    urlattrs={this.props.urlattrs}
                                    remotemeta={this.state.data.metadata}
                                    onRowAdded={this.onRowAdded.bind(this)}
                                    childProps={this.props.childProps}
                                />
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-lg-12">
                                <EdiTable
                                    data={this.state.data}
                                    metadata={this.state.metadata}
                                    url={url}
                                    urlattrs={this.props.urlattrs}
                                    childProps={this.props.childProps}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </Panel>
        )
    }
}

